import React from "react"
import { Link } from "react-router-dom"

const RecentCard = ({ listings = [] }) => {
  if (listings.length === 0) {
    return <p className='recent-empty'>No listings yet. Check back soon.</p>
  }
  return (
    <div className='content grid3 mtop'>
      {listings.map((item) => {
        const { id, cover, category, location, name, price, type } = item
        return (
          <Link to={`/listings/${id}`} className='box shadow recent-card-link' key={id}>
            <div className='img'>
              <img src={cover || "/images/placeholder.jpg"} alt={name || "Property"} />
            </div>
            <div className='text'>
              <div className='category flex'>
                <span style={{ background: category === "For Sale" ? "#25b5791a" : "#ff98001a", color: category === "For Sale" ? "#25b579" : "#ff9800" }}>{category}</span>
              </div>
              <h4>{name}</h4>
              <p>
                <i className='fa fa-location-dot'></i> {location || "—"}
              </p>
            </div>
            <div className='button flex'>
              <div>
                <span className='btn2'>{price}</span>
                {category === "For Rent" && <label>/month</label>}
              </div>
              <span>{type}</span>
            </div>
          </Link>
        )
      })}
    </div>
  )
}

export default RecentCard
